import { createSlice } from '@reduxjs/toolkit';
import { Role } from '../constants';

import { AppDispatch } from 'store';
import * as api from '../api';

type GeneralSlice = {
  error?: string;
  role?: Role;
  email?: string;
};

export const generalSlice = createSlice({
  name: 'general',
  initialState: {
    error: undefined,
    role: undefined,
    email: undefined,
  } as GeneralSlice,
  reducers: {
    setError: (state, { payload }: { payload: string }) => {
      state.error = payload;
    },
    clearError: (state) => {
      state.error = '';
    },
    setRole(state, { payload }) {
      state.role = payload;
    },
    setEmail(state, { payload }) {
      state.email = payload;
    },
  },
});

const { setError, clearError, setRole, setEmail } = generalSlice.actions;

export { setError, clearError };

export function reloadRole() {
  return async (dispatch: AppDispatch): Promise<Role> => {
    try {
      const { role, email } = await api.fetchRole();
      dispatch(setRole(role));
      dispatch(setEmail(email));

      return role;
    } catch (err) {
      dispatch(setError('Something went wrong. Please refresh the page'));
      console.error('Failed to fetch role', err);
      dispatch(setRole(Role.public));
      return Role.public;
    }
  };
}

export default generalSlice.reducer;
